import type { StyleProperties } from '../../LoginSocialBar.types';

const getAvatarAndArrowStrokeWidth = (styleProperties: StyleProperties) => {
  let avatarAndArrowStrokeWidth: string;

  const typeofAvatarStrokeWidth =
    typeof styleProperties.avatarAndArrowStrokeWidth;
  // we receive avatarAndArrowStrokeWidth sometimes with 'px' sometimes without
  if (
    typeofAvatarStrokeWidth === 'number' ||
    (typeofAvatarStrokeWidth === 'string' &&
      !styleProperties.avatarAndArrowStrokeWidth.includes('px'))
  ) {
    avatarAndArrowStrokeWidth = `${styleProperties.avatarAndArrowStrokeWidth}px`;
  } else {
    avatarAndArrowStrokeWidth = styleProperties.avatarAndArrowStrokeWidth;
  }

  return {
    ...(avatarAndArrowStrokeWidth && {
      '--avatarAndArrowStrokeWidth': avatarAndArrowStrokeWidth,
    }),
  };
};

export const getFixedCSSVars = (styleProperties: StyleProperties) => {
  return {
    ...getAvatarAndArrowStrokeWidth(styleProperties),
  };
};
